import {useTranslation} from 'react-i18next'

import {IconClock} from '@sdox/icons'
import {Accordion} from '@sdox/ui'

import {OpeningHoursTable} from './OpeningHoursTable'

import type {OpeningHours} from './OpeningHoursTable'

interface OpeningHoursDisplayProps {
  openingHours: OpeningHours
}

export const OpeningHoursDisplay = (props: OpeningHoursDisplayProps) => {
  const {openingHours} = props
  const {t} = useTranslation()

  // for some dealers, all opening hours are null or empty string
  const hasOpeningHours = Object.values(openingHours).some(Boolean)
  if (!hasOpeningHours) return null

  return (
    <div className={'py-spacing-40 sm:pr-spacing-8'}>
      <div className={'hidden sm:block'}>
        <div className={'flex gap-spacing-16'}>
          <IconClock />
          {t('common:dealerStamp.openingHours')}:
        </div>
        <div className={'my-spacing-12 pl-spacing-40'}>
          <OpeningHoursTable openingHours={openingHours} />
        </div>
      </div>
      <div className={'sm:hidden'}>
        <Accordion title={t('common:dealerStamp.openingHours')}>
          <OpeningHoursTable openingHours={openingHours} />
        </Accordion>
      </div>
    </div>
  )
}
